const UTM_KEYS = ['utm_source', 'utm_medium', 'utm_campaign', 'utm_term', 'utm_content'];
const STORAGE_KEY = 'utm_params';

// Cookie (e não só sessionStorage) para a UTM sobreviver ao fechamento da aba:
// em eventos com internet ruim o participante costuma abrir o link do vendor,
// a página falha/fecha e ele volta depois sem os parâmetros na URL — sem isso o
// cadastro/primeiro acesso chegava sem atribuição.
const COOKIE_MAX_AGE_DAYS = 7;

const pickUtmKeys = (source) => UTM_KEYS.reduce((acc, key) => {
  if (source?.[key]) acc[key] = String(source[key]);
  return acc;
}, {});

const readCookie = () => {
  try {
    const entry = document.cookie.split('; ').find(c => c.startsWith(`${STORAGE_KEY}=`));
    if (!entry) return null;
    return pickUtmKeys(JSON.parse(decodeURIComponent(entry.slice(STORAGE_KEY.length + 1))));
  } catch {
    return null;
  }
};

const writeCookie = (utms) => {
  try {
    const secure = window.location.protocol === 'https:' ? '; Secure' : '';
    const value = encodeURIComponent(JSON.stringify(utms));
    document.cookie = `${STORAGE_KEY}=${value}; Max-Age=${COOKIE_MAX_AGE_DAYS * 24 * 60 * 60}; Path=/; SameSite=Lax${secure}`;
  } catch {
    // cookies bloqueados — sessionStorage continua como fallback
  }
};

// Last-touch: uma nova UTM na URL substitui a anterior
export function captureUtmParams() {
  const params = new URLSearchParams(window.location.search);
  const utms = {};
  UTM_KEYS.forEach(key => {
    const value = params.get(key);
    if (value) utms[key] = value;
  });
  if (Object.keys(utms).length > 0) {
    writeCookie(utms);
    try {
      sessionStorage.setItem(STORAGE_KEY, JSON.stringify(utms));
    } catch {
      // ignora
    }
  }
}

export function getUtmParams() {
  const fromCookie = readCookie();
  if (fromCookie && Object.keys(fromCookie).length > 0) return fromCookie;
  try {
    return pickUtmKeys(JSON.parse(sessionStorage.getItem(STORAGE_KEY)));
  } catch {
    return {};
  }
}
